
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  template: `
      <button class='breadcrumbs__return' @click="returnToPrev()">
        <i class="icons8-chevron-left-2 breadcrumbs__return--icon"></i>
        {{ label }}
      </button>
  `
})
export default class BackButton extends Vue {
  @Prop({ default: 'Verder winkelen' }) label: string
  @Prop({ default: true }) useHistory: boolean

  returnToPrev() {
    if(this.useHistory) {
      history.back()
    }
    else {
      const url = new URL(window.location.href)
      const pathname = url.pathname.split('/')
      pathname.pop()
      url.pathname = pathname.join('/')
      const returnUrl = url.searchParams.get('returnUrl')

      if (returnUrl) {
        window.location.href = returnUrl.toString()
      }
      else if(document.referrer && document.referrer === url.toString()){
        history.back()
      }
      else {
        window.location.href = url.toString()
      }

    }
  }
}
